import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("i", {
    class: _normalizeClass([_ctx.icon, _ctx.iconClass, 'mp-icon']),
    style: _normalizeStyle(_ctx.iconStyle),
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.handleClick && _ctx.handleClick.apply(_ctx, arguments);
    })
  }, null, 6
  /* CLASS, STYLE */
  );
}